<li *ngIf="rounds && rounds.length > 1" ngbDropdown class="nav-item nav-roundItem.round">
    <a href="javascript:void(0)" id="dropdownRounds" class="nav-link" ngbDropdownToggle>Select Round</a>
    <div ngbDropdownMenu aria-labelledby="dropdownRounds">
        <a href="javascript:void(0)" *ngFor="let roundItem of rounds" ngbDropdownItem (click)="changeRound(roundItem)"
                [class.active]="roundItem.round == round.round">
            <span>Round {{ roundItem.round }}</span>
        </a>
    </div>
</li>
